import { HStack, Image, Text } from "@chakra-ui/react";
import { NavLink } from "react-router";

export const HomeLink = () => (
  <NavLink to="/" style={{ width: "fit-content" }}>
    <HStack gap={1} w={20}>
      <Image src="/assets/hub-logo-feather.svg" boxSize={7} />
      <Text fontSize="17.5px" fontWeight="800" lineHeight="24.5px" letterSpacing="-0.7px">
        portal
      </Text>
    </HStack>
  </NavLink>
);
